/**
 * Extras Include With Bookings Filter, used for filtering extras for display and extra categories based on includeWithBookingsProperty
 */
bookingApp.filter('extrasExcludeOnValidityPeriod',['$filter',function() {
    var extrasFilter = function (input, isItemOnly) {
        var out = [];
        angular.forEach(input, function (extra) {
            if(!isItemOnly){
                if(!extra.validityPeriod){
                    out.push(extra);
                }
            } else {
                out.push(extra)
            }
        });
        return out;
    };
    return extrasFilter;
}]);